import { type ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { tokens } from '../../styles/tokens';
import { useLocaleStore } from './localeStore';

type Props = { children: ReactNode };

const ANTD_LOCALE = {
  'zh-CN': zhCN,
  'en-US': enUS,
} as const;

export function LocaleConfigProvider({ children }: Props) {
  const locale = useLocaleStore((s) => s.locale);

  return (
    <ConfigProvider
      locale={ANTD_LOCALE[locale]}
      theme={{
        token: {
          colorPrimary: tokens.color.primary,
          colorSuccess: tokens.color.success,
          colorWarning: tokens.color.warning,
          colorError: tokens.color.danger,
          borderRadius: tokens.radius.md,
          fontFamily: tokens.fontFamily,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
